import React from 'react'
import values from 'lodash/values'
import find from 'lodash/find'
import some from 'lodash/some'
import isEqual from 'lodash/isEqual'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import {
  compose,
  lifecycle,
  withProps,
  branch,
  renderComponent,
} from 'recompose'
import { fetchProductSlider } from './productActions'
import { makeSelectProductList } from '../elementSelectors'

const findFetchingSkuList = ({ products, skuList }) => {
  const availableProducts = products.filter((product) => !!product)
  return skuList.filter(
    (sku) => (
      sku !== '' &&
      !find(availableProducts, (product) => product.sku === sku)
    ),
  )
}

const Dummy = styled.div`
  height: 380px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20;
  font-weight: 700;
  box-shadow: inset rgb(159, 159, 159) 0px 0px 5px 0px;
  background-color: #f5f5f5;
`

const findSomeFailureStatus = (fetchStatusBySku) => {
  const productListStatus = values(fetchStatusBySku)
  return some(productListStatus, ({ isFailure }) => isFailure)
}

export default () => compose(
  connect(
    () => {
      const selectProducts = makeSelectProductList()

      return (state, props) => selectProducts(state, props)
    },
    (dispatch) => bindActionCreators({ fetchProductSlider }, dispatch),
  ),
  withProps(({
    defaultContent,
  }) => ({
    skuList: defaultContent.skuList,
  })),
  lifecycle({
    componentDidMount() {
      const {
        fetchProductSlider,
        api,
      } = this.props
      const validSkuList = findFetchingSkuList(this.props)
      if (validSkuList.length) {
        // fetch when no product and sku is not empty
        fetchProductSlider(api, validSkuList)
      }
    },
    componentWillReceiveProps(nextProps) {
      const {
        fetchProductSlider,
        api,
      } = nextProps
      const validSkuList = findFetchingSkuList(this.props)
      const validNextSkuList = findFetchingSkuList(nextProps)
      if (!isEqual(validSkuList, validNextSkuList) && validNextSkuList.length) {
        // some sku change, fetch new products
        fetchProductSlider(api, validNextSkuList)
      }
    },
  }),
  branch(
    ({ skuList, fetchStatusBySku }) => !skuList.length || findSomeFailureStatus(fetchStatusBySku),
    renderComponent(
      ({ renderElement, fetchStatusBySku }) => renderElement(
        () => (
          <Dummy>
            {findSomeFailureStatus(fetchStatusBySku) ? 'Some SKU is not found' : 'Please specify product sku list'}
          </Dummy>
        ),
      ),
    ),
  ),
)




// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/product/withProductSlider.js